import React from "react";

import { useIntl } from "react-intl";

import FullPageError from "Components/FullPageError";
import { Link } from "ds/Button";
import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  environmentSelector,
  environmentLoadingSelector,
  environmentErrorSelector
} from "Reducers/environment";

type EnvironmentErrorProps = {
  children: React.ReactNode;
};

const EnvironmentError = ({ children }: EnvironmentErrorProps) => {
  const intl = useIntl();
  const { organizationId, projectId } = useDecodedParams<{
    organizationId: string;
    projectId: string;
  }>();

  const environment = useSelectorWithUrlParams(environmentSelector);
  const isLoading = useSelectorWithUrlParams(environmentLoadingSelector);
  const environmentLoadingError = useSelectorWithUrlParams(
    environmentErrorSelector
  );

  let errorTitle = intl.formatMessage({ id: "error_loading_environment" });
  let errorMessage = intl.formatMessage({
    id: "error_loading_environment_description"
  });

  if (!isLoading && environmentLoadingError) {
    if ((environmentLoadingError as { code: unknown }).code === 403) {
      errorTitle = intl.formatMessage({ id: "error_403_title" });
      errorMessage = intl.formatMessage({ id: "error_environment_403" });
    }
  }

  const shouldShowError =
    !isLoading && (environmentLoadingError || !environment);

  return shouldShowError ? (
    <FullPageError title={errorTitle} message={errorMessage}>
      <div className="actions">
        <Link
          variant="primary"
          analyticId="return_to_projects"
          to={`/${organizationId}/${projectId}`}
        >
          {intl.formatMessage({ id: "return_to_projects" })}
        </Link>
      </div>
    </FullPageError>
  ) : (
    <>{children}</>
  );
};

export default EnvironmentError;
